import { Col, Container, Row } from "reactstrap";
import { AboutListData, ChooseUsContent } from "../../../data/demo/CarDemo2";
import { dynamicImage, dynamicSvg, Image } from "../../../utils";
import { Link } from "react-router-dom";
import { routes } from "../../../routers/routes";
import CommonHeader from "../common/CommonHeader";
import { ChooseUs, LearnMore } from "../../../constants";

const AboutUs = () => {
  return (
    <section className="car2-about section-t-lg-space position-relative">
      <Image src={dynamicImage("car2/bg-effect/about-bg.png")} alt="about-bg" className="img-fluid position-absolute dots-bg" />
      <Container>
        <Row className="m-auto align-items-center justify-content-between">
          <Col lg="6" className="p-0 d-lg-inline-block d-none">
            <div className="about-img">
              <Image src={dynamicImage("car2/about-img.png")} alt="about-img" className="img-fluid" />
            </div>
          </Col>
          <Col lg="6">
            <div className="about-content">
              <CommonHeader title={ChooseUs} content={ChooseUsContent} />
              <ul className="about-list">
                {AboutListData.map((item, index) => (
                  <li key={index}>
                    <div className="about-icon">
                      <Image src={dynamicSvg(item.image)} alt="image" className="img-fluid" />
                    </div>
                    <h6>{item.title}</h6>
                  </li>
                ))}
              </ul>
              <Link to={routes.Pages.Other.AboutUs1} className="btn-pills">
                {LearnMore}
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUs;
